<template>
    <div class="feature_images">
        <swiper ref="swiper" class="pc" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item.image});`"></div>
                    <div class="text">
                        <div class="title">{{item.title}}</div>
                        <div class="desc" v-html="textToHtml(item.desc)"></div>
                    </div>
                </swiper-slide>
            </template>
        </swiper>
        <swiper ref="mobileSwiper" class="mobile" :options="mobileOptions">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item.image});`"></div>
                    <div class="text">
                        <div class="title">{{item.title}}</div>
                        <div class="desc" v-html="textToHtml(item.desc)"></div>
                    </div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev pc" slot="button-prev"></div>
        <div class="swiper-button-next pc" slot="button-next"></div>
        <div class="swiper-button-prev mobile" slot="button-prev"></div>
        <div class="swiper-button-next mobile" slot="button-next"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import lineBreaks from '../utils/lineBreaks';
export default {
    name: "featureImages",
    props: [ 'data' ],
    data() {
        return {
            options: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.feature_images .swiper-button-prev.pc',
                    nextEl: '.feature_images .swiper-button-next.pc',
                },
                observer: true,
                observeParents: true,
                spaceBetween: '4.1666%',
            },
            mobileOptions: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.feature_images .swiper-button-prev.mobile',
                    nextEl: '.feature_images .swiper-button-next.mobile',
                },
                observer: true,
                observeParents: true,
                spaceBetween: '9.56%',
                autoHeight: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
        mobileSwiper() {
            return this.$refs.mobileSwiper.swiper
        },
        textToHtml: lineBreaks.textToHtml
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    watch: {},
    methods: {},
    destroyed() {},
};
</script>

<style scoped lang="scss">
.feature_images{
    position: relative;
    margin-bottom: .5rem;
    overflow: hidden;
    .mobile{
        display: none;
    }
    .swiper-container{
        width: 100%;
    }
    .swiper-slide{
        width: 2rem;
        height: 2rem;
        border-radius: .04rem;
        overflow: hidden;
        &:hover{
            .text{
                opacity: 1;
            }
        }
        .cover{
            width: 100%;
            height: 100%;
            background: no-repeat center/cover;
        }
        .text{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba($color: #000000, $alpha: .3);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #fff;
            opacity: 0;
            transition: opacity .5s;
            line-height: 1.6;
            .title{
                font-size: .18rem;
                text-align: center;
                margin-bottom: .05rem;
                font-weight: bold;
            }
            .desc{
                width: 100%;
                padding: 0 .1rem;
                text-align: justify;
                font-size: .15rem;
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .14rem;
        height: .18rem;
        background: no-repeat 0/100%;
        margin-top: 0;
        transform: translate(0, -50%);
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: -.3rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: -.3rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem;
        margin-bottom: 0;
        .pc{
            display: none;
        }
        .mobile{
            display: block;
            overflow: visible;
        }
        .swiper-slide{
            width: 4.7rem;
            height: auto;
            .cover{
                height: 4.7rem;
            }
            .text{
                opacity: 1;
                position: relative;
                background: #e6e6e6;
                padding: .5rem .25rem;
                color: #000;
                .title{
                    font-size: .48rem;
                }
            }
        }
        .swiper-button-prev,
        .swiper-button-next{
            width: .64rem;
            height: .82rem;
        }
        .swiper-button-prev{
            left: .35rem;
        }
        .swiper-button-next{
            right: .35rem;
        }
    }
}
</style>